import { render, staticRenderFns } from "./clarification.vue?vue&type=template&id=4f1ea3ef&scoped=true"
import script from "./clarification.vue?vue&type=script&lang=js"
export * from "./clarification.vue?vue&type=script&lang=js"
import style0 from "./clarification.vue?vue&type=style&index=0&id=4f1ea3ef&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1ea3ef",
  null
  
)

export default component.exports